import styled, { css, keyframes } from 'styled-components';
import { tokens } from '../../components/modal-form/tokens';

export const Tela = styled.div`
    min-height: 100vh;
    font-family: ${tokens.fontFamily};
    color: ${tokens.textPrimary};
    background:
        radial-gradient(1200px 600px at 85% -20%, rgba(255, 255, 255, 0.08), transparent 60%),
        ${tokens.primaryGradient};
    background-attachment: fixed;
    padding: 0 16px 48px;
`;

export const Topo = styled.header`
    max-width: 960px;
    margin: 0 auto;
    padding: 28px 0 16px;
    color: rgba(255, 255, 255, 0.85);
    font-size: ${tokens.fontSm};
    font-weight: 500;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const BarraFundo = styled.div`
    height: 3px;
    border-radius: 2px;
    background: rgba(255, 255, 255, 0.18);
    overflow: hidden;
`;

export const BarraCheia = styled.div<{ $pct: number }>`
    height: 100%;
    width: ${p => p.$pct}%;
    background: #ffffff;
    transition: width ${tokens.transitionSlow};
`;

export const Painel = styled.main<{ $compacto?: boolean }>`
    max-width: 960px;
    margin: 0 auto;
    background: ${tokens.bgWhite};
    border-radius: ${tokens.radiusLg};
    box-shadow: ${tokens.shadowLg};
    padding: ${p => p.$compacto ? '14px 24px 14px' : '32px 36px 24px'};

    @media (max-width: ${tokens.breakpointMd}) {
        padding: ${p => p.$compacto ? '12px 14px' : '22px 18px 18px'};
    }
`;

export const Titulo = styled.h1`
    font-size: 1.35rem;
    font-weight: 600;
    color: ${tokens.textPrimary};
    margin: 0 0 6px;
`;

export const Subtitulo = styled.p`
    font-size: ${tokens.fontBase};
    color: ${tokens.textMuted};
    margin: 0 0 24px;
    line-height: 1.5;
`;

export const Rodape = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 28px;
    padding-top: 18px;
    border-top: 1px solid ${tokens.borderLight};
    font-size: ${tokens.fontSm};
    color: ${tokens.textMuted};
`;

export const Botao = styled.button<{ $variante?: 'primario' | 'secundario' | 'link' }>`
    border: 1px solid transparent;
    border-radius: ${tokens.radiusMd};
    padding: 9px 20px;
    font-size: ${tokens.fontBase};
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-decoration: none;
    color: #ffffff;
    background: ${tokens.primaryGradient};
    transition: background ${tokens.transitionFast}, border-color ${tokens.transitionFast}, opacity ${tokens.transitionFast};

    &:hover:not(:disabled) { background: ${tokens.primaryGradientHover}; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }

    ${p => p.$variante === 'secundario' && css`
        background: ${tokens.bgWhite};
        color: ${tokens.primaryColor};
        border-color: ${tokens.borderDefault};
        &:hover:not(:disabled) { background: ${tokens.bgLight}; border-color: ${tokens.primaryColor}; }
    `}

    ${p => p.$variante === 'link' && css`
        background: transparent;
        color: ${tokens.textMuted};
        padding: 9px 4px;
        font-weight: 500;
        &:hover:not(:disabled) { background: transparent; color: ${tokens.primaryColor}; }
    `}
`;

export const Aviso = styled.div<{ $tipo?: 'info' | 'erro' | 'ok' }>`
    display: flex;
    gap: 10px;
    align-items: flex-start;
    border-radius: ${tokens.radiusMd};
    padding: 10px 14px;
    font-size: ${tokens.fontSm};
    line-height: 1.5;
    background: ${tokens.primaryLight};
    color: ${tokens.textSecondary};
    border: 1px solid #cfe6fb;

    svg { flex-shrink: 0; margin-top: 2px; color: ${tokens.primaryColor}; }

    ${p => p.$tipo === 'erro' && css`background: #fdf2f3; border-color: #f5c6cb; color: #842029; svg { color: ${tokens.errorColor}; }`}
    ${p => p.$tipo === 'ok' && css`background: #eef8f1; border-color: #c3e6cb; color: #1e5631; svg { color: ${tokens.successColor}; }`}
`;

export const GradeDores = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 10px;
`;

export const OpcaoDor = styled.button<{ $selecionado: boolean; $bloqueado: boolean }>`
    display: flex;
    align-items: center;
    gap: 12px;
    text-align: left;
    padding: 12px 14px;
    border: 1px solid ${tokens.borderLight};
    border-radius: ${tokens.radiusLg};
    background: ${tokens.bgWhite};
    font-family: inherit;
    font-size: ${tokens.fontMd};
    font-weight: 500;
    color: ${tokens.textPrimary};
    cursor: pointer;
    transition: border-color ${tokens.transitionFast}, background ${tokens.transitionFast};

    > svg:first-child { font-size: 16px; color: ${tokens.primaryColor}; flex-shrink: 0; }
    span { flex: 1; }
    .check { font-size: 14px; color: ${tokens.primaryColor}; flex-shrink: 0; }

    &:hover { border-color: ${tokens.borderFocus}; }

    ${p => p.$selecionado && css`
        border-color: ${tokens.primaryColor};
        background: ${tokens.primaryLight};
    `}
    ${p => p.$bloqueado && css`
        opacity: 0.5;
        cursor: not-allowed;
        &:hover { border-color: ${tokens.borderLight}; }
    `}
`;

// Uma placa por vez na etapa da frota.
export const CampoPlaca = styled.input`
    width: 100%;
    max-width: 280px;
    border: 1px solid ${tokens.borderDefault};
    border-radius: ${tokens.radiusMd};
    padding: 10px 14px;
    font-size: 1.1rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    font-family: inherit;
    color: ${tokens.textPrimary};
    outline: none;
    transition: border-color ${tokens.transitionFast}, box-shadow ${tokens.transitionFast};

    &::placeholder { font-weight: 400; letter-spacing: normal; text-transform: none; color: ${tokens.textHint}; }
    &:focus { border-color: ${tokens.borderFocus}; box-shadow: 0 0 0 3px rgba(31, 70, 126, 0.12); }
`;

export const GradeVeiculos = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
    gap: 10px;
    margin-top: 20px;
`;

export const CartaoVeiculo = styled.div<{ $estado: 'ok' | 'pendente' | 'inativo' }>`
    border: 1px solid ${tokens.borderLight};
    border-radius: ${tokens.radiusLg};
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: ${tokens.fontMd};

    ${p => p.$estado === 'ok' && css`border-color: rgba(40, 167, 69, 0.45); background: rgba(40, 167, 69, 0.06);`}
    ${p => p.$estado === 'pendente' && css`border-color: #ffe08a; background: ${tokens.warningBg};`}
    ${p => p.$estado === 'inativo' && css`opacity: 0.6;`}

    .linha { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
    .nome { font-weight: 600; color: ${tokens.textPrimary}; }
    .detalhe { color: ${tokens.textMuted}; font-size: ${tokens.fontSm}; }
    .fipe { font-weight: 600; color: ${tokens.textSecondary}; white-space: nowrap; }
    .chassi { font-family: 'Consolas', 'Menlo', monospace; color: ${tokens.textSecondary}; letter-spacing: 0.02em; }
    .campos .inteiro { grid-column: 1 / -1; }

    input, select {
        width: 100%;
        border: 1px solid ${tokens.borderDefault};
        border-radius: ${tokens.radiusSm};
        padding: 6px 9px;
        font-size: ${tokens.fontSm};
        font-family: inherit;
        outline: none;
        background: ${tokens.bgWhite};
        &:focus { border-color: ${tokens.borderFocus}; }
    }

    .campos { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; }
`;

export const BotaoIcone = styled.button`
    border: none;
    background: transparent;
    color: ${tokens.textHint};
    cursor: pointer;
    padding: 4px;
    border-radius: ${tokens.radiusSm};
    display: inline-flex;
    &:hover { color: ${tokens.errorColor}; background: ${tokens.bgLight}; }
`;

export const Etiqueta = styled.span<{ $cor: 'verde' | 'amarelo' | 'cinza' | 'azul' }>`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: ${tokens.fontXs};
    font-weight: 600;
    border-radius: ${tokens.radiusSm};
    padding: 2px 8px;
    align-self: flex-start;
    ${p => p.$cor === 'verde' && css`background: #e8f5ec; color: #1e7b34;`}
    ${p => p.$cor === 'amarelo' && css`background: #fff3cd; color: #856404;`}
    ${p => p.$cor === 'cinza' && css`background: ${tokens.bgLight}; color: ${tokens.textMuted};`}
    ${p => p.$cor === 'azul' && css`background: ${tokens.primaryLight}; color: ${tokens.primaryColor};`}
`;

export const QrBloco = styled.div`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
`;

export const QrItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 12px;
    border: 1px solid ${tokens.borderLight};
    border-radius: ${tokens.radiusMd};
    color: ${tokens.textSecondary};
    font-size: ${tokens.fontSm};
    font-weight: 500;

    a { display: flex; flex-direction: column; align-items: center; gap: 8px; color: inherit; text-decoration: none; }
    span { display: inline-flex; align-items: center; gap: 6px; }

    button {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        border: none;
        background: none;
        padding: 2px 4px;
        font: inherit;
        font-size: ${tokens.fontXs};
        font-weight: 600;
        color: ${tokens.primaryColor};
        cursor: pointer;
        &:hover { text-decoration: underline; }
    }
`;

export const Credenciais = styled.div`
    margin-top: 16px;
    border: 1px solid ${tokens.borderLight};
    border-radius: ${tokens.radiusMd};
    background: ${tokens.bgLight};

    .item { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 14px; }
    .item + .item { border-top: 1px solid ${tokens.borderLight}; }
    small { color: ${tokens.textMuted}; display: block; font-size: ${tokens.fontXs}; }
    strong { font-family: 'Consolas', 'Menlo', monospace; font-size: ${tokens.fontLg}; font-weight: 600; color: ${tokens.textPrimary}; overflow-wrap: anywhere; }
`;

export const Aguardando = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 14px;
    font-size: ${tokens.fontSm};
    color: ${tokens.textMuted};
`;

export const ZonaArquivo = styled.label<{ $arrastando: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 32px 16px;
    border: 1.5px dashed ${tokens.borderDefault};
    border-radius: ${tokens.radiusLg};
    background: ${tokens.bgLight};
    color: ${tokens.textMuted};
    font-size: ${tokens.fontMd};
    text-align: center;
    cursor: pointer;
    transition: border-color ${tokens.transitionFast}, background ${tokens.transitionFast};

    svg { font-size: 26px; color: ${tokens.primaryColor}; }
    strong { color: ${tokens.textPrimary}; font-weight: 600; }
    input { display: none; }

    &:hover { border-color: ${tokens.primaryColor}; }
    ${p => p.$arrastando && css`border-color: ${tokens.primaryColor}; background: ${tokens.primaryLight};`}
`;

export const ListaMarcacoes = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${tokens.borderLight};
    border-radius: ${tokens.radiusLg};
    max-height: 420px;
    overflow-y: auto;
`;

export const LinhaMarcacao = styled.div`
    display: grid;
    grid-template-columns: 1fr 220px auto;
    gap: 12px;
    align-items: center;
    padding: 10px 14px;
    font-size: ${tokens.fontSm};
    color: ${tokens.textSecondary};

    & + & { border-top: 1px solid ${tokens.borderLight}; }

    .trecho { line-height: 1.5; word-break: break-word; }
    mark { background: #fff3cd; color: ${tokens.textPrimary}; padding: 1px 3px; border-radius: 3px; }

    select {
        width: 100%;
        border: 1px solid ${tokens.borderDefault};
        border-radius: ${tokens.radiusSm};
        padding: 6px 8px;
        font-size: ${tokens.fontSm};
        font-family: inherit;
        background: ${tokens.bgWhite};
    }

    @media (max-width: 720px) {
        grid-template-columns: 1fr auto;
        select { grid-column: 1 / -1; grid-row: 2; }
    }
`;

// Atalho para a tela de uma prioridade; abre em outra guia (o painel fica onde está).
export const CartaoCaminho = styled.a`
    display: flex;
    text-decoration: none;
    font: inherit;
    width: 100%;
    flex-direction: column;
    gap: 6px;
    text-align: left;
    padding: 14px 16px;
    border: 1px solid ${tokens.borderLight};
    border-radius: ${tokens.radiusLg};
    background: ${tokens.bgWhite};
    font-family: inherit;
    cursor: pointer;
    transition: border-color ${tokens.transitionFast};

    .titulo { display: flex; align-items: center; gap: 10px; font-weight: 600; font-size: ${tokens.fontMd}; color: ${tokens.textPrimary}; }
    .titulo svg { color: ${tokens.primaryColor}; }
    .texto { font-size: ${tokens.fontSm}; color: ${tokens.textMuted}; line-height: 1.45; }
    .acao { font-size: ${tokens.fontSm}; font-weight: 600; color: ${tokens.primaryColor}; display: inline-flex; align-items: center; gap: 6px; }

    &:hover { border-color: ${tokens.primaryColor}; text-decoration: none; }
`;

export const AreaLocacao = styled.div`
    min-height: 80px;
`;

// Aviso por cima da primeira locação quando o contrato não pôde ser gerado: a pessoa escolhe
// seguir sem o contrato ou voltar ao formulário.
export const FundoAviso = styled.div`
    position: fixed;
    inset: 0;
    z-index: 2000;
    background: rgba(15, 23, 42, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
`;

export const CartaoAviso = styled.div`
    width: 100%;
    max-width: 520px;
    background: ${tokens.bgWhite};
    border-radius: ${tokens.radiusLg};
    box-shadow: 0 20px 50px rgba(15, 23, 42, 0.25);
    padding: 24px;

    h2 { margin: 0 0 8px; font-size: 19px; color: ${tokens.textPrimary}; }
    p { margin: 0 0 12px; font-size: ${tokens.fontBase}; color: ${tokens.textSecondary}; line-height: 1.5; }
    .acoes { display: flex; flex-wrap: wrap; justify-content: flex-end; gap: 10px; margin-top: 18px; }
`;

const girar = keyframes`
    to { transform: rotate(360deg); }
`;

export const Carregando = styled.span`
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 2px solid ${tokens.borderLight};
    border-top-color: ${tokens.primaryColor};
    animation: ${girar} 0.8s linear infinite;
`;

export const CampoNome = styled.input`
    width: 100%;
    max-width: 420px;
    border: 1px solid ${tokens.borderDefault};
    border-radius: ${tokens.radiusMd};
    padding: 9px 12px;
    font-size: ${tokens.fontBase};
    font-family: inherit;
    color: ${tokens.textPrimary};
    outline: none;
    &:focus { border-color: ${tokens.borderFocus}; box-shadow: 0 0 0 3px rgba(31, 70, 126, 0.12); }
`;

export const Rotulo = styled.label`
    display: block;
    font-size: ${tokens.fontSm};
    font-weight: 600;
    color: ${tokens.textSecondary};
    margin: 0 0 6px;
`;

export const Chips = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
`;

export const Chip = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: ${tokens.fontSm};
    font-weight: 500;
    color: ${tokens.primaryColor};
    background: ${tokens.primaryLight};
    border: 1px solid #cfe6fb;
    border-radius: ${tokens.radiusSm};
    padding: 3px 9px;
`;

export const Destaque = styled.div`
    display: flex;
    gap: 14px;
    align-items: flex-start;
    margin: 0 0 24px;
    padding: 16px 18px;
    border-radius: ${tokens.radiusMd};
    background: ${tokens.primaryLight};
    border: 1px solid #b6d4f2;
    border-left: 4px solid ${tokens.primaryColor};

    > svg { font-size: 20px; color: ${tokens.primaryColor}; flex-shrink: 0; margin-top: 1px; }
    strong { display: block; font-size: ${tokens.fontLg}; font-weight: 600; color: ${tokens.primaryColor}; margin-bottom: 2px; }
    span { font-size: ${tokens.fontMd}; color: ${tokens.textSecondary}; }
`;

export const Secao = styled.div`
    margin-top: 20px;
`;

export const FaixaExperimento = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    border-radius: ${tokens.radiusMd};
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.22);
    color: #ffffff;
    font-size: ${tokens.fontSm};
    line-height: 1.45;

    svg { flex-shrink: 0; font-size: 15px; }
    strong { font-weight: 600; }
`;

// Passo numerado ("1 Instale o app", "2 Entre com o acesso do cliente").
export const Passo = styled.div`
    display: flex;
    gap: 14px;
    align-items: flex-start;

    & + & { margin-top: 22px; }

    > span {
        flex-shrink: 0;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: ${tokens.primaryColor};
        color: #ffffff;
        font-weight: 700;
        font-size: ${tokens.fontSm};
        display: flex;
        align-items: center;
        justify-content: center;
    }

    > div { flex: 1; min-width: 0; }

    h3 { margin: 3px 0 10px; font-size: ${tokens.fontMd}; font-weight: 600; color: ${tokens.textPrimary}; }
`;

// Faixa de sucesso (verde transparente) para os momentos de "deu certo".
export const FaixaSucesso = styled.div`
    display: flex;
    gap: 14px;
    align-items: flex-start;
    margin: 0 0 22px;
    padding: 16px 18px;
    border-radius: ${tokens.radiusLg};
    background: rgba(40, 167, 69, 0.1);
    border: 1px solid rgba(40, 167, 69, 0.28);

    > svg { font-size: 26px; color: #28a745; flex-shrink: 0; margin-top: 2px; }
    h1 { margin: 0 0 4px; font-size: 1.35rem; font-weight: 600; color: #1e5631; }
    p { margin: 0; font-size: ${tokens.fontBase}; color: #2f6b3f; line-height: 1.5; }
`;

// Rótulo com ícone ao lado do texto (e não em cima).
export const RotuloComIcone = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    font-size: ${tokens.fontSm};
    font-weight: 600;
    color: ${tokens.textSecondary};

    svg { color: #28a745; flex-shrink: 0; }
`;

// Contrato gerado, mostrado na própria página.
export const FolhaContrato = styled.div`
    border: 1px solid ${tokens.borderLight};
    border-radius: ${tokens.radiusMd};
    background: #f3f4f6;
    /* Cabe na tela com a faixa de sucesso e o botão Continuar. */
    height: calc(100vh - 270px);
    min-height: 240px;
    overflow: auto;

    iframe { width: 100%; height: 100%; border: none; display: block; }
    .docx-wrapper { background: #f3f4f6 !important; padding: 8px !important; }
    .docx-wrapper > section.docx { box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12) !important; margin-bottom: 8px !important; padding: 28px 36px !important; min-height: 0 !important; }

    mark.campo-auto {
        background: #ffe58a;
        box-shadow: inset 0 -2px 0 #e0b400;
        color: inherit;
        padding: 0 1px;
        border-radius: 2px;
        cursor: help;
        transition: background 0.3s;
    }
    mark.campo-auto.em-foco { background: #ffc94d; box-shadow: 0 0 0 3px rgba(224, 180, 0, 0.45); }
`;

export const FaixaSucessoCompacta = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 10px;
    font-size: ${tokens.fontBase};
    flex-wrap: wrap;
    color: #1e5631;

    > svg { color: #28a745; font-size: 18px; flex-shrink: 0; }
    strong { font-weight: 600; }
`;

export const EtiquetaPreenchido = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
    padding: 7px 14px;
    border-radius: 8px;
    background: linear-gradient(90deg, #143C8F 0%, #335EDB 100%);
    color: #ffffff;
    font-size: ${tokens.fontSm};
    font-weight: 500;
    white-space: nowrap;
    cursor: help;

    svg { color: #ffffff; font-size: 15px; }
`;
